import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import Invoices from "../../component/invoice/invoices.js";
import moment from 'moment';

import {NavLink} from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import GetAppIcon from '@material-ui/icons/GetApp';
import Chip from '@material-ui/core/Chip';

import 'moment/locale/fr';
moment.locale('fr');

const options = {
  filterType: 'checkbox',
  viewColumns: false,
  selectableRows: false,
  responsive: 'scroll',
  rowHover: false,
  textLabels: {
    body: {
      noMatch: "Désolé, aucun résultat n'a été trouvé",
      toolTip: "Sort",
    },
    pagination: {
      next: "Suivant",
      previous: "Précédent",
      rowsPerPage: "Lignes par page:",
      displayRows: "de",
    },
    toolbar: {
      search: "Recherche",
      downloadCsv: "Téléchrager CSV",
      print: "Imprimer",
      viewColumns: "Visibilité des colonnes",
      filterTable: "Filtres",
    },
    filter: {
      all: "Tous",
      title: "FILTRES",
      reset: "ANNULER",
    },
    viewColumns: {
      title: "Visibilité des colonnes",
      titleAria: "Affiche/Cacher des colonnes",
    },
    selectedRows: {
      text: "ligne(s) sélectionnée(s)",
      delete: "Supprimer",
      deleteAria: "Supprimer les lignes sélectionnée(s)",
    },
  },
  customSort: (data, colIndex, order) => {
          if(colIndex === 1){

              return order === "asc" ? data.sort((a, b) => {
                  if (a.data[colIndex] === null || a.data[colIndex] === "") {
                      return 1;
                  }
                  else if (b.data[colIndex] === null || b.data[colIndex] === "") {
                      return -1;
                  }
                  else if (a.data[colIndex]  === b.data[colIndex] ) {
                      return 0;
                  }
                  var timestamp_a = moment(a.data[colIndex], 'DD/MM/YYYY').toDate();
                  var timestamp_b = moment(b.data[colIndex], 'DD/MM/YYYY').toDate();
                  return (timestamp_a < timestamp_b) - (timestamp_a > timestamp_b);
              }) : data.sort((a, b) => {
                  if (a.data[colIndex] === null || a.data[colIndex] === "") {
                      return 1;
                  }
                  else if (b.data[colIndex] === null || b.data[colIndex] === "") {
                      return -1;
                  }
                  else if (a.data[colIndex]  === b.data[colIndex] ) {
                      return 0;
                  }
                  var timestamp_a = moment(a.data[colIndex], 'DD/MM/YYYY').toDate();
                  var timestamp_b = moment(b.data[colIndex], 'DD/MM/YYYY').toDate();
                  return (timestamp_a > timestamp_b) - (timestamp_a < timestamp_b);
              });
          }else{
              return order === "asc" ? data.sort((a, b) => (a.data[colIndex] < b.data[colIndex]) - (a.data[colIndex] > b.data[colIndex])) : data.sort((a, b) => (a.data[colIndex] > b.data[colIndex]) - (a.data[colIndex] < b.data[colIndex]));
          }

  }
};

class Invoicescon extends React.Component{
  constructor(props) {
    super(props);

      this.handleInvoiceRemove = this.handleInvoiceRemove.bind(this);
      this.addDataToDatatable = this.addDataToDatatable.bind(this);
    this.state = {
      data: [],
      loading: true,
      columns: [
        {name: "Action(s)",options: {filter: false,sort: false,customBodyRender: (value, tableMeta, updateValue) => {
          return (
              <div style={{display: 'flex'}}>
              <Tooltip title="Ouvrir">
                <span style={{width: 48, height: 48}}>
                  <NavLink style={{textDecoration: 'none', width: 48, height: 48, margin: 11, display: 'block', color: '#3f51b5'}} to={"/invoices/" + value}><OpenInBrowserIcon /></NavLink>
                </span>
              </Tooltip>
              <Tooltip title="Télécharger">
                <span style={{width: 48, height: 48}}>
                  <IconButton aria-label="Generate" onClick={
                    () => this.props.generateInvoiceAction(
                        value,
                        "Facture_" + this.props.user.company_name + "_Qualibat_" + (this.props.invoices.find(invoice => parseInt(invoice.id, 10) === parseInt(value, 10)).audits.length > 0 ? (this.props.invoices.find(invoice => parseInt(invoice.id, 10) === parseInt(value, 10)).audits[0].company.department + "_") : "") + moment().format('MMYYYY')
                        )
                  }>
                    <GetAppIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Supprimer">
                <span style={{width: 48, height: 48}}>
                  <IconButton aria-label="Delete" onClick={() => this.props.displayConfirmation("Suppression", "Êtes-vous sûr de vouloir supprimer cette facture ?", () => this.handleInvoiceRemove(value))}>
                    <DeleteOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </div>
          );
        } }},
        {name: "Date",options: {filter: false, sort: true, sortDirection: 'desc'}},
        "Réf.",
        "Total (TTC)",
          {name: "Entreprise(s)",options: {filter: false,sort: false,customBodyRender: (value, tableMeta, updateValue) => {
                return (
                    <div>
                        {value.split(', ').map((val, index) => (
                            <Chip key={index} label={val.split(" | ")[1]} style={{margin: 5}} variant="outlined" />
                        ))}
                    </div>
                );
            }
          }
          },
      ]
    }
  }

  handleInvoiceRemove(id) {
    this.props.removeInvoiceAction(id).then(res=>{
      /* supprime la facture du tableau */
      this.setState(function(prevState){
        return { data : prevState.data.filter(function(val, i) {
          return val[0] !== id;
        })};
      })
      this.props.getAuditsAction();
    })
    this.props.closeConfirmation()
  }

  componentWillMount() {
      /* import les factures depuis le state */
      this.addDataToDatatable();
  }

    componentDidMount() {
        /* import les factures */
        this.props.getInvoicesAction().then(res => {
            this.addDataToDatatable(true);
        }).catch(err => {
            this.props.displaySnackbar("error", "Erreur de chargement");
            this.setState({loading: false})
        })
    }

  addDataToDatatable(loaded){
      let data = []
      /* Convertie les objects en array */
      for (var i in this.props.invoices) {
          let values = []
          let obj = this.props.invoices[i];
          obj.hasOwnProperty("id") && obj.id ? values.push(obj.id.toString()) : values.push("")
          obj.hasOwnProperty("date") && obj.date ? values.push(moment(obj.date).format('DD/MM/YYYY')) : values.push("")
          obj.hasOwnProperty("reference") && obj.reference ? values.push(obj.reference) : values.push("")

          let audits = obj.audits.map((audit) => {
              return audit.reference + " | " + audit.company.name
          })
          let total = 0;
          for(var j = 0; j < obj.audits.length; j++){
              total += obj.audits[j].type.price;
          }
          obj.hasOwnProperty("audits") && audits ? values.push(total + (this.props.user.tva_percent ? (total * (this.props.user.tva_percent/100)) : 0 )) : values.push("")
          obj.hasOwnProperty("audits") && audits ? values.push(audits.join(', ')) : values.push("")

          data.push(values)
      }
      if(loaded){
          this.setState({
              data: data,
              loading: false,
          })
      }else{
          this.setState({
              data: data,
          })
      }
  }

  render(){
    return <Invoices columns={this.state.columns} data={this.state.data} options={options} loading={this.state.loading}></Invoices>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Invoicescon);



// WEBPACK FOOTER //
// ./src/container/invoice/invoices-container.js